import styled from 'styled-components';

export const StyledIcon = styled.i(({ theme: { color, transition } }) => ({
  color: color.content.reversed.default(),
  transition: transition.standard('color'),
}));

export const Wrapper = styled.div(({ theme: { color } }) => ({
  cursor: 'pointer',

  '&:focus-visible': {
    outline: `2px solid ${color.border.accent.default()}`,
  },

  '&:hover': {
    [StyledIcon]: {
      color: color.content.reversed.hover(),
    },
  },
}));
